(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    function wire(host) {
      if (host.getAttribute('data-pcg-shine-wired') === 'true') return;
      host.setAttribute('data-pcg-shine-wired', 'true');
      var raf = 0;
      var pending = null;

      function flush() {
        raf = 0;
        if (!pending) return;
        var e = pending;
        pending = null;
        var rect = host.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        host.style.setProperty('--pcg-mx', String(Math.round(e.clientX)));
        host.style.setProperty('--pcg-my', String(Math.round(e.clientY)));
        host.style.setProperty('--pcg-shine-opacity', '1');
      }

      host.addEventListener(
        'pointermove',
        function (e) {
          pending = e;
          if (!raf) raf = requestAnimationFrame(flush);
        },
        { passive: true }
      );

      host.addEventListener('pointerleave', function () {
        pending = null;
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
        host.style.setProperty('--pcg-shine-opacity', '0');
      });
    }

    document.querySelectorAll('.product-card-grid-shine-host').forEach(wire);

    document.addEventListener('collection:updated', function () {
      document.querySelectorAll('.product-card-grid-shine-host').forEach(wire);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
